"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PurchaseTerm = require("./PurchaseTerm");
Object.keys(_PurchaseTerm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PurchaseTerm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PurchaseTerm[key];
    }
  });
});